var map = {
	"./arrowRight-icon.png": 5127,
	"./data-empty.png": 1186,
	"./downFile-icon.png": 1960,
	"./footer-icon.png": 8429,
	"./link-test.png": 2037,
	"./newsTrend-logo.png": 3828,
	"./openInfo-logo.png": 584,
	"./pause.png": 4262,
	"./tes2.png": 388,
	"./tes3.png": 3421,
	"./test1.png": 7217,
	"./toTop.png": 300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5909;